"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.childComponents = exports.TEXT_TYPE = exports.SIDEBAR_ICONS = exports.LABEL = void 0;

var _react = _interopRequireDefault(require("react"));

var childComponents = [/*#__PURE__*/_react.default.createElement("div", null, " "), /*#__PURE__*/_react.default.createElement("div", null, " ")];
exports.childComponents = childComponents;
var SIDEBAR_ICONS = {
  HotelIcon: {
    type: 'HotelIcon',
    ActiveColor: 'tertiary',
    InActiveColor: 'greyDarker',
    size: 'titleNormal'
  },
  FlightIcon: {
    type: 'FlightIcon',
    ActiveColor: 'tertiary',
    InActiveColor: 'greyDarker',
    size: 'titleNormal'
  }
};
exports.SIDEBAR_ICONS = SIDEBAR_ICONS;
var TEXT_TYPE = {
  default: {
    type: 'default',
    size: 'normal',
    lineHeight: 'normal',
    marginLeft: 'tiny'
  }
};
exports.TEXT_TYPE = TEXT_TYPE;
var LABEL = {
  hotel: 'Hotel'
};
exports.LABEL = LABEL;